import React, { useState, useEffect, useRef } from 'react';
import select_Dropdown_Arrow from "../../../images/select_arrow.svg";
import "./selectDropdown.css";

/**
 * Custom HecoAnalytics dropdown component
 */

export const SelectDropdown = ({ values, valueOptions, onValueChange }) => {
  const [value, setValue] = useState(values || '');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  let placeholder = "Select..."

  useEffect(() => {
    setValue(values);
  }, [values]);

  const handleSelect = (option) => {
    setValue(option);
    onValueChange(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-select-container" ref={dropdownRef}>
      <div
        className="formrow-value-selectinput"
        onClick={() => setIsOpen(!isOpen)}
        style={{ color: value ? 'black' : 'var(--darkGrey)' }}
      >
        {value || placeholder}
        <img src={select_Dropdown_Arrow} alt='arrow down'/>
      </div>
      {isOpen && (
        <div className="dropdown-options">
          {valueOptions.split(',').map((option, index) => (
            <div
              key={index}
              className={`dropdown-option ${option.trim() === value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.trim())}
            >
              {option.trim()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

